/******************************************************************************
 *
 * Copyright (c) 2019-2020 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Vishal Goel’ <vishal@wakencode.com>, February 2020
 *
 *****************************************************************************/

import * as actionTypes from "./actionTypes";
import { axiosSA } from "../../axios";
import { toast } from "react-toastify";
import { constant } from "./../../shared/constants/constants";
import { setToken } from "./index";
import { convertCoordinatesV1toV0 } from "../../shared/helper";

// fetch replay coordinates
export const fetchReplayCoordinates = (
  startDateTime,
  endDateTime,
  equipmentId
) => {
  return async (dispatch, getState) => {
    // refresh idToken
    let token = await dispatch(setToken());
    let toastId = toast.info(constant.FETCHING_COORDINATES);
    axiosSA
      .get("/coordinates", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          startDateTime: startDateTime.utc().format(),
          endDateTime: endDateTime.utc().format(),
          equipmentId: equipmentId,
        },
      })
      .then((res) => {
        // Dismiss above toast notification
        toast.dismiss(toastId);
        dispatch(
          setCoordinate(convertCoordinatesV1toV0(res.data[0]).coordinates)
        );
        if (res.data[0].coordinates.length > 0) {
          toast.success(constant.PRESS_PLAY_TO_SEE_PATH);
        } else {
          // show no coordinates found toast
          toast.info(constant.NO_COORDINATES_FOUND);
        }
      })
      .catch((err) => {
        // Dismiss above toast notification
        toast.dismiss(toastId);

        // show some error occurred toast
        toast.error(constant.SOME_ERROR_OCCURRED);
        // console.log("coordinate error", err);
      });
  };
};

// set replay coordinates in redux store
export const setCoordinate = (coordinates) => {
  return {
    type: actionTypes.SET_COORDINATE,
    coordinates: coordinates,
  };
};
